import { useEffect, useState } from "react";
import { API } from "./api";

const FALLBACK = { business_name: "WorkBase Systems", tagline: "Systems for businesses that do the work." };
let cache = null;
let pending = null;

export function useBrand() {
  const [brand, setBrand] = useState(cache || FALLBACK);
  useEffect(() => {
    if (cache) { setBrand(cache); return; }
    if (!pending) {
      pending = fetch(`${API}/public/config`)
        .then((r) => r.json())
        .then((d) => { cache = { ...FALLBACK, ...d }; return cache; })
        .catch(() => null);
    }
    pending.then((d) => d && setBrand(d));
  }, []);
  return brand;
}
